import { create } from "zustand";

import type { User } from "@/types";

interface SessionState {
  user: User | null;
  /** Birinchi tekshiruv tugamaguncha `true`. Kirilmagan bilan adashtirmang. */
  isChecking: boolean;
  setUser: (user: User | null) => void;
  setChecking: (value: boolean) => void;
  clear: () => void;
}

/**
 * Joriy sessiya.
 *
 * MUHIM: bu yerda TOKEN YO'Q va bo'lmaydi. Sessiya `httpOnly` cookie'da
 * (ADR 0004) — JS uni o'qiy olmaydi, ya'ni XSS uni o'g'irlay olmaydi.
 * Bu do'kon faqat "kim kirgan" degan savolga javob beradi.
 *
 * `persist` ham ataylab yo'q: localStorage'dagi eski foydalanuvchi
 * ma'lumoti backend allaqachon bloklagan hisobni "faol" ko'rsatib turishi
 * mumkin. Har yuklashda `/auth/me` so'raladi — bu bitta so'rov, lekin
 * holat har doim haqiqiy.
 */
export const useSessionStore = create<SessionState>(set => ({
  user: null,
  isChecking: true,
  setUser: user => set({ user, isChecking: false }),
  setChecking: isChecking => set({ isChecking }),
  clear: () => set({ user: null, isChecking: false }),
}));
